import styled, { css } from 'styled-components';

import { font } from '../../../atoms/typography';
import { color } from '../../../atoms/colors';
import { spacing } from '../../../atoms/spacing';

export const Container = styled.div`
  width: 100%;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid ${color.darkBlue[50]};
  ${props => props?.expanded && `padding-bottom: ${spacing[16]};`}
`;

export const Button = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${color.common.transparent};
  outline: none;
  border: none;
  padding: ${spacing[16]} ${spacing[0]};

  &:hover,
  &:focus {
    background: ${color.common.transparent};
    color: ${color.darkBlue[1000]};
    outline: none;
    border: none;
    ${font('text', 'md', '700')}
  }

  svg {
    ${props => props?.expanded && 'transform: rotate(180deg);'}
  }

  .filter-heading {
    display: flex;
    align-items: center;
    gap: ${spacing[8]};
    ${font('text', 'md', '700')}
    text-align: left;
    color: ${color.darkBlue[1000]};
  }

  .count {
    width: ${spacing[24]};
    height: ${spacing[24]};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${spacing[32]};
    border-radius: ${spacing[56]};
    background: ${color.blue[50]};
    ${font('text', 'xs', '400')}
    color: ${color.darkBlue[600]};
  }
`;

export const Filters = styled.div`
  width: 100%;
  max-height: 0px;
  display: flex;
  flex-direction: column;
  gap: ${spacing[12]};
  overflow-y: auto;
  transition: max-height 300ms ease-in-out, padding-bottom 300ms ease-in-out;

  &::-webkit-scrollbar {
    width: ${spacing[8]};
  }

  &::-webkit-scrollbar-track {
    background: ${color.grey[200]};
    border-top-right-radius: ${spacing[8]};
    border-bottom-right-radius: ${spacing[8]};
  }

  &::-webkit-scrollbar-thumb {
    background: ${color.blue[700]};
    border-radius: ${spacing[8]};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  ${props =>
    props?.expanded &&
    css`
      max-height: 300px;
      padding-bottom: 12px;
    `}
`;

export const OrderButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  padding: ${spacing[4]} ${spacing[8]};
  background-color: ${color.common.transparent};
  border-color: ${color.common.transparent};
  outline: none;
  border-radius: ${spacing[8]};
  ${font('text', 'md', '400')}
  text-align: left;

  color: ${color.darkBlue[1000]};
  ${props => props.active && `background: ${color.darkBlue[25]};`}
  &:hover {
    background: ${color.darkBlue[25]};
  }
`;
